import { useRef } from 'react'

import { isKeyEvent } from './processor/helpers'

export const isHistoryEvent = (event: React.KeyboardEvent): boolean => {
  return isKeyEvent(event, 'KeyZ', 90)
}

const useHistory = <T>(
  callback: (value: T) => void,
  initialData: T,
): [(value: T) => void, () => void, () => void, (value: T) => void] => {
  const undoRef = useRef<T[]>([])
  const redoRef = useRef<T[]>([])
  const valueRef = useRef<T>(initialData)

  const setValue = (value: T) => {
    if (value === valueRef.current) {
      return
    }

    const redoHistory = redoRef.current
    redoHistory.length = 0

    const undoHistory = undoRef.current
    undoHistory.push(valueRef.current)
    valueRef.current = value
    callback(value)
  }

  const step = (from: T[], to: T[]) => {
    const value = from.pop()
    if (value !== undefined) {
      to.push(valueRef.current)
      valueRef.current = value
      callback(value)
    }
  }

  const undo = () => step(undoRef.current, redoRef.current)

  const redo = () => step(redoRef.current, undoRef.current)

  const replace = (value: T) => {
    valueRef.current = value
  }

  return [setValue, undo, redo, replace]
}

export default useHistory
